// Port of api/fuel/app/classes/controller/api/monty/players/suggest.php
import DB from 'offline/db'

function userIndex(params) {
	if (params.type === 'users') {
		var users = DB.query('SELECT user_id FROM user WHERE user_name = ? LIMIT 1', [params.name || ''])
		return users.length ? [parseInt(users[0].user_id, 10) || 0] : []
	}

	if (params.type === 'groups') {
		var groups = DB.query('SELECT group_id FROM groups WHERE group_slug = ? LIMIT 1', [params.name || ''])
		if (!groups.length) return []
		return DB.query('SELECT user_id FROM link_group_user WHERE group_id = ?', [groups[0].group_id]).map(function(row) {
			return parseInt(row.user_id, 10) || 0
		}).filter(Boolean)
	}

	return []
}

export default function(params) {
	var text = (params.text || '').toLowerCase()
	var exclude = Array.isArray(params.exclude) && params.exclude.length ? params.exclude.map(function(id) {
		return parseInt(id, 10) || 0
	}).filter(Boolean) : [0]

	if (!text) return Promise.resolve({ session: { offline: true }, data: { suggestions: {} } })

	var users = userIndex(params)
	if (!users.length) return Promise.resolve({ session: { offline: true }, data: { suggestions: {} } })

	var playIds = DB.query('SELECT play_id FROM play WHERE user_id IN (' + users.map(function() { return '?' }).join(', ') + ')', users).map(function(row) {
		return parseInt(row.play_id, 10) || 0
	}).filter(Boolean)

	if (!playIds.length) return Promise.resolve({ session: { offline: true }, data: { suggestions: {} } })

	var sql = 'SELECT MIN(player_id) AS player_id, player_name, player_username FROM player WHERE play_id IN (' + playIds.map(function() { return '?' }).join(', ') + ') AND player_id NOT IN (' + exclude.map(function() { return '?' }).join(', ') + ') AND player_name <> ? AND (LOWER(player_username) LIKE ? OR LOWER(player_name) LIKE ?) GROUP BY player_name ORDER BY LENGTH(player_name) ASC, player_name ASC LIMIT 25'
	var rows = DB.query(sql, playIds.concat(exclude).concat(['', '%' + text + '%', '%' + text + '%']))
	var suggestions = {}

	for (var i = 0; i < rows.length; i++) {
		var row = rows[i]
		var playerId = parseInt(row.player_id, 10) || 0
		if (!playerId) continue
		suggestions[playerId] = {
			player_id: playerId,
			player_name: row.player_name,
			player_username: row.player_name !== row.player_username ? row.player_username : ''
		}
	}

	return Promise.resolve({ session: { offline: true }, data: { suggestions: suggestions } })
}
